import { UXCustomizationType } from "@gtmhub/uxcustomization/models";
import NavigationItemsMediator from "@webapp/navigation/services/uxcustomization/navigation-items.mediator.service";
import { INavItem, uxcToNavItemsMap } from "@webapp/navigation/models/nav-items-list.models";
import { Subscription } from "rxjs";
import { ICollection } from "@gtmhub/models";

export class FavoritesManager {
  public static $inject = ["NavigationItemsMediator"];
  private entityTypes: UXCustomizationType[];
  private favoritesSubscription: Subscription;
  private favoritesCollection: ICollection<INavItem>;

  constructor(private navigationItemsMediator: NavigationItemsMediator, entityTypes: UXCustomizationType[]) {
    this.entityTypes = entityTypes;
    this.favoritesCollection = { items: [], totalCount: 0 };
  }

  $onDestroy(): void {
    this.favoritesSubscription.unsubscribe();
  }

  public initFavorites() {
    this.navigationItemsMediator.loadFavorites(uxcToNavItemsMap[this.entityTypes[0]]);
    this.favoritesSubscription = this.navigationItemsMediator.getFavoritesItems$(uxcToNavItemsMap[this.entityTypes[0]]).subscribe((favoritesCollection) => {
      this.favoritesCollection = favoritesCollection || { items: [], totalCount: 0 };
    });
  }

  public entityIsFavorite = (entity: { id: string }): boolean => {
    const favorite = this.favoritesCollection.items.find((favItem) => favItem.id === entity.id);
    return !!favorite;
  };

  public getFavoriteItem = (entity: { id: string }): INavItem => {
    return this.favoritesCollection.items.find((favItem) => favItem.id === entity.id);
  };

  public addToFavorites = (entity: { id: string }, type: UXCustomizationType, navItem: INavItem) => {
    this.navigationItemsMediator.markItemAsFavorite(entity.id, type, navItem, uxcToNavItemsMap[navItem.uxcType]);
  };

  public removeFromFavorites = (entity: { id: string }, navItem: INavItem) => {
    const existingNavItem = this.favoritesCollection.items.find((favoriteItem) => favoriteItem.id === entity.id);
    this.navigationItemsMediator.unmarkItemAsFavorite(existingNavItem.favoriteId, navItem.uxcType, navItem, uxcToNavItemsMap[navItem.uxcType]);
  };
}
